import { Flex, Heading, Text } from '@chakra-ui/react';
import { memo } from 'react';
import { LuSparkles } from 'react-icons/lu';

const AISummary = () => {
  return (
    <Flex direction="column" gap={2}>
      <Flex align="center" gap={2}>
        <LuSparkles />
        <Heading size="md">AI Summary</Heading>
      </Flex>
      <Text fontSize="sm">
        Ipsum dolor sit amet, consectetur adipiscing elit. The AI summary is a summary of the hedge
        position generated by AI.
      </Text>
    </Flex>
  );
};

export default memo(AISummary);
